import { retryCancelablePromise } from '../core/utils/retryCancelablePromise';
export class ApiMonitoringService {
    constructor(httpRequest) {
        Object.defineProperty(this, "httpRequest", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: httpRequest
        });
    }
    /**
     * Restart api monitoring runner jobs
     * @returns any OK.
     * @throws ApiError
     */
    restartApiMonitoringRunnerJobs(options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'POST', url: '/api-monitoring-jobs-utils', errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get monthly workflow usage
     * Returns the monthly usage of a workflow for an organization.
     * @returns ApiMonitoringWorkflowUsage Successfully retrieved workflow usage.
     * @throws ApiError
     */
    getMonthlyWorkflowUsage({ orgId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/api-monitoring-workflow-usage', path: {
                'orgId': orgId,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Upsert api monitoring job
     * @returns ApiMonitoringJobBulkResponse Multi Status.
     * @throws ApiError
     */
    bulkSyncJobs({ orgId, projectId, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'PUT', url: '/orgs/{orgId}/projects/{projectId}/api-monitoring-jobs', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Upsert api monitoring preview jobs
     * @returns ApiMonitoringJobBulkResponse Multi Status.
     * @throws ApiError
     */
    bulkSyncPreviewJobs({ orgId, projectId, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'PUT', url: '/orgs/{orgId}/projects/{projectId}/api-monitoring-preview-jobs', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Upsert api monitoring workflows
     * @returns ApiMonitoringWorkflowBulkResponse Multi Status.
     * @throws ApiError
     */
    bulkSyncWorkflows({ orgId, projectId, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'PUT', url: '/orgs/{orgId}/projects/{projectId}/api-monitoring-workflows', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get list of api monitoring workflows
     * @returns ApiMonitoringWorkflowList OK.
     * @throws ApiError
     */
    listWorkflows({ orgId, projectId, after, before, limit = 10, filter, sort = '-id', search, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/api-monitoring-workflows', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, query: {
                'after': after,
                'before': before,
                'limit': limit,
                'filter': filter,
                'sort': sort,
                'search': search,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get api monitoring workflow by ID
     * @returns ApiMonitoringWorkflow OK.
     * @throws ApiError
     */
    getWorkflow({ orgId, projectId, apiMonitoringWorkflowId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/api-monitoring-workflows/{apiMonitoringWorkflowId}', path: {
                'orgId': orgId,
                'projectId': projectId,
                'apiMonitoringWorkflowId': apiMonitoringWorkflowId,
            }, errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Delete api monitoring workflow by ID
     * @returns void
     * @throws ApiError
     */
    deleteWorkflow({ orgId, projectId, apiMonitoringWorkflowId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'DELETE', url: '/orgs/{orgId}/projects/{projectId}/api-monitoring-workflows/{apiMonitoringWorkflowId}', path: {
                'orgId': orgId,
                'projectId': projectId,
                'apiMonitoringWorkflowId': apiMonitoringWorkflowId,
            }, errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Create api monitoring workflow run
     * @returns ApiMonitoringWorkflowRun Api monitoring workflow run created.
     * @throws ApiError
     */
    createWorkflowRun({ orgId, projectId, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'POST', url: '/orgs/{orgId}/projects/{projectId}/api-monitoring-workflow-runs', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get list of api monitoring workflow runs
     * @returns ApiMonitoringWorkflowRunList OK.
     * @throws ApiError
     */
    listWorkflowRuns({ orgId, projectId, after, before, limit = 10, filter, sort = '-id', search, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/api-monitoring-workflow-runs', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, query: {
                'after': after,
                'before': before,
                'limit': limit,
                'filter': filter,
                'sort': sort,
                'search': search,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get list of api monitoring workflow runs analytics for chart
     * @returns ApiMonitoringWorkflowRunsChartAnalyticsList OK.
     * @throws ApiError
     */
    listWorkflowRunsChartAnalytics({ orgId, projectId, limit = 10, filter, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/api-monitoring-workflow-runs-chart-analytics', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, query: {
                'limit': limit,
                'filter': filter,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get api monitoring workflow run by ID
     * @returns ApiMonitoringWorkflowRun OK.
     * @throws ApiError
     */
    getWorkflowRun({ orgId, projectId, apiMonitoringWorkflowRunId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/api-monitoring-workflow-runs/{apiMonitoringWorkflowRunId}', path: {
                'orgId': orgId,
                'projectId': projectId,
                'apiMonitoringWorkflowRunId': apiMonitoringWorkflowRunId,
            }, errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Update api monitoring workflow run by ID
     * @returns ApiMonitoringWorkflowRun OK.
     * @throws ApiError
     */
    updateWorkflowRun({ orgId, projectId, apiMonitoringWorkflowRunId, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'PUT', url: '/orgs/{orgId}/projects/{projectId}/api-monitoring-workflow-runs/{apiMonitoringWorkflowRunId}', path: {
                'orgId': orgId,
                'projectId': projectId,
                'apiMonitoringWorkflowRunId': apiMonitoringWorkflowRunId,
            }, body: requestBody, mediaType: 'application/json', errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Delete api monitoring workflow run by ID
     * @returns void
     * @throws ApiError
     */
    deleteWorkflowRun({ orgId, projectId, apiMonitoringWorkflowRunId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'DELETE', url: '/orgs/{orgId}/projects/{projectId}/api-monitoring-workflow-runs/{apiMonitoringWorkflowRunId}', path: {
                'orgId': orgId,
                'projectId': projectId,
                'apiMonitoringWorkflowRunId': apiMonitoringWorkflowRunId,
            }, errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * List workflow statistics
     * Returns a paginated list of workflow statistics including uptime, last duration, and average duration.
     * @returns ApiMonitoringWorkflowStatsList Successfully retrieved workflow statistics.
     * @throws ApiError
     */
    listWorkflowStats({ orgId, projectId, after, before, limit = 10, filter, sort = '-id', search, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/api-monitoring-workflow-stats', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, query: {
                'after': after,
                'before': before,
                'limit': limit,
                'filter': filter,
                'sort': sort,
                'search': search,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Upsert api monitoring notifications slack config
     * @returns ApiMonitoringNotificationsSlackConfig Api monitoring notifications slack config created.
     * @throws ApiError
     */
    upsertNotificationsSlackConfig({ orgId, projectId, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'PUT', url: '/orgs/{orgId}/projects/{projectId}/api-monitoring-notifications-slack-configs', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get list of api monitoring notifications slack configs
     * @returns ApiMonitoringNotificationsSlackConfigList OK.
     * @throws ApiError
     */
    listNotificationsSlackConfigs({ orgId, projectId, after, before, limit = 10, filter, sort = '-id', search, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/api-monitoring-notifications-slack-configs', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, query: {
                'after': after,
                'before': before,
                'limit': limit,
                'filter': filter,
                'sort': sort,
                'search': search,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Delete api monitoring notifications slack config by ID
     * @returns void
     * @throws ApiError
     */
    deleteNotificationsSlackConfig({ orgId, projectId, apiMonitoringNotificationsSlackConfigId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'DELETE', url: '/orgs/{orgId}/projects/{projectId}/api-monitoring-notifications-slack-configs/{apiMonitoringNotificationsSlackConfigId}', path: {
                'orgId': orgId,
                'projectId': projectId,
                'apiMonitoringNotificationsSlackConfigId': apiMonitoringNotificationsSlackConfigId,
            }, errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Create api monitoring notifications email config
     * @returns ApiMonitoringNotificationsEmailConfig Api monitoring notifications email config created.
     * @throws ApiError
     */
    createNotificationsEmailConfig({ orgId, projectId, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'POST', url: '/orgs/{orgId}/projects/{projectId}/api-monitoring-notifications-email-configs', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get list of api monitoring notifications email configs
     * @returns ApiMonitoringNotificationsEmailConfigList OK.
     * @throws ApiError
     */
    listNotificationsEmailConfigs({ orgId, projectId, after, before, limit = 10, filter, sort = '-id', search, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/api-monitoring-notifications-email-configs', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, query: {
                'after': after,
                'before': before,
                'limit': limit,
                'filter': filter,
                'sort': sort,
                'search': search,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Upsert api monitoring notifications email config
     * @returns ApiMonitoringNotificationsEmailConfig Api monitoring notifications email config updated.
     * @throws ApiError
     */
    upsertNotificationsEmailConfig({ orgId, projectId, requestBody, apiMonitoringNotificationsEmailConfigId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'PUT', url: '/orgs/{orgId}/projects/{projectId}/api-monitoring-notifications-email-configs/{apiMonitoringNotificationsEmailConfigId}', path: {
                'orgId': orgId,
                'projectId': projectId,
                'apiMonitoringNotificationsEmailConfigId': apiMonitoringNotificationsEmailConfigId,
            }, body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Delete api monitoring notifications email config by ID
     * @returns void
     * @throws ApiError
     */
    deleteNotificationsEmailConfig({ orgId, projectId, apiMonitoringNotificationsEmailConfigId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'DELETE', url: '/orgs/{orgId}/projects/{projectId}/api-monitoring-notifications-email-configs/{apiMonitoringNotificationsEmailConfigId}', path: {
                'orgId': orgId,
                'projectId': projectId,
                'apiMonitoringNotificationsEmailConfigId': apiMonitoringNotificationsEmailConfigId,
            }, errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
}
//# sourceMappingURL=ApiMonitoringService.js.map